import { render } from "./PageHeader.vue?vue&type=template&id=58ab548f"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/julian.thomson/Sites/j/carter/themes/base/.yarn/__virtual__/vue-loader-virtual-a1e10e0710/0/cache/vue-loader-npm-17.0.0-6ebaa2d3c5-a6eb675f07.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/PageHeader/PageHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58ab548f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58ab548f', __exports__)) {
    api.reload('58ab548f', __exports__)
  }
  
  module.hot.accept("./PageHeader.vue?vue&type=template&id=58ab548f", () => {
    api.rerender('58ab548f', render)
  })

}


export default __exports__